import store from '@/store';
import { Actions } from '@/store/enums/StoreEnums';
import { IBreadcrumbLink } from '@/store/modules/BreadcrumbsModule';

/**
 * Sets current page breadcrumbs
 * @param {string} pageTitle Current page title
 * @param {Array<string>} breadcrumbs Current page breadcrumbs
 */
export const setCurrentPageBreadcrumbs = (
  pageTitle: string,
  breadcrumbs: Array<string>
): void => {
  store.dispatch(Actions.SET_BREADCRUMB_ACTION, {
    title: pageTitle,
    pageBreadcrumbPath: breadcrumbs,
  });
};

/**
 * Sets current page breadcrumbs
 * @param {string} title Current page title name
 */
export const setCurrentPageTitle = (title: string): void => {
  store.dispatch(Actions.SET_BREADCRUMB_ACTION, {
    title: title,
  });
};

export const setBreadcrumbLinks = (
  breadcrumbs: IBreadcrumbLink[],
  withHomePage = true
): void => {
  if (withHomePage) {
    store.dispatch(Actions.SET_BREADCRUMB_ITEMS_ACTION, [
      {
        text: 'Trang chủ',
        routeData: {
          name: 'dashboard',
        },
      },
      ...breadcrumbs,
    ]);

    return;
  }

  store.dispatch(Actions.SET_BREADCRUMB_ITEMS_ACTION, breadcrumbs);
};
